export default "/assets/images/smog-video-thumbnail.19876598e922c572.jpg";